export const normalizationSettings = decision => ({
  letter_case: decision?.value_normalization?.letter_case || "original",
  trailing_period: decision?.value_normalization?.trailing_period === true
});
export const STANDARD_NORMALIZATION = Object.freeze({
  letter_case: "sentence",
  trailing_period: true
});
